export default "__VITE_ASSET__BIC7HNLB__"